(function () {
  const MIN_READY_DELAY_MS = 350;
  const MAX_WAIT_MS = 20000;
  const POLL_INTERVAL_MS = 200;
  const MIN_SLIDER_HEIGHT = 80;
  const STABLE_VISIBLE_CHECKS = 3;

  function getPowrRoot(slider) {
    return slider.querySelector('.powr-image-slider, [class*="powr-image-slider"]');
  }

  function getSliderImages(slider) {
    return Array.from(slider.querySelectorAll('img[src]')).filter((img) => {
      return !img.closest('.home-slider-shell__placeholder');
    });
  }

  function getPowrHeight(slider) {
    const powrRoot = getPowrRoot(slider);
    if (!powrRoot) return 0;

    const iframe = powrRoot.querySelector('iframe');
    const indexedNode = powrRoot.querySelector('[powrindex]') || powrRoot;
    const heights = [
      powrRoot.getBoundingClientRect().height,
      powrRoot.offsetHeight,
      parseInt(powrRoot.style.height, 10) || 0,
      parseInt(indexedNode.getAttribute('height'), 10) || 0,
      Number(indexedNode.height) || 0
    ];

    if (iframe) {
      heights.push(
        iframe.getBoundingClientRect().height,
        iframe.offsetHeight,
        parseInt(iframe.height, 10) || 0,
        parseInt(iframe.style.height, 10) || 0,
        Number(iframe.height) || 0
      );
    }

    return Math.max(...heights);
  }

  function isElementVisible(element) {
    if (!element) return false;

    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (parseFloat(style.opacity) === 0) return false;

    const rect = element.getBoundingClientRect();
    return rect.width > 40 && rect.height >= MIN_SLIDER_HEIGHT;
  }

  function sliderImagesAreVisible(slider) {
    const images = getSliderImages(slider);
    return images.some((img) => {
      return img.complete && img.naturalHeight > 0 && isElementVisible(img);
    });
  }

  function powrSliderIsVisible(slider) {
    const powrRoot = getPowrRoot(slider);
    if (!powrRoot) return false;

    if (powrRoot.querySelector('#app-preloader')) return false;

    const iframe = powrRoot.querySelector('iframe');
    if (!iframe) return false;

    if (!isElementVisible(iframe)) return false;

    const rootHeight = getPowrHeight(slider);
    return rootHeight >= MIN_SLIDER_HEIGHT;
  }

  function sliderIsVisible(slider) {
    return sliderImagesAreVisible(slider) || powrSliderIsVisible(slider);
  }

  function revealSlider(shell) {
    if (shell.classList.contains('is-slider-visible')) return;

    const placeholder = shell.querySelector('.home-slider-shell__placeholder');
    const inner = shell.querySelector('.home-slider-shell__inner');
    const slider = shell.querySelector('.home-slider-shell__slider');
    const placeholderHeight = placeholder ? placeholder.offsetHeight : 0;
    const sliderHeight = Math.max(getPowrHeight(slider), slider ? slider.offsetHeight : 0);
    const targetHeight = Math.max(placeholderHeight, sliderHeight);

    if (targetHeight > 0 && inner) {
      inner.style.minHeight = `${Math.round(targetHeight)}px`;
    }

    shell.classList.add('is-slider-visible');

    if (slider) {
      slider.removeAttribute('aria-hidden');
    }

    const removePlaceholder = () => {
      if (placeholder && placeholder.parentNode) {
        placeholder.remove();
      }
      if (inner) {
        inner.style.minHeight = '';
      }
    };

    if (placeholder) {
      placeholder.addEventListener('transitionend', removePlaceholder, { once: true });
      window.setTimeout(removePlaceholder, 650);
    } else if (inner) {
      inner.style.minHeight = '';
    }
  }

  function initHomeSliderShell(shell) {
    if (shell.dataset.homeSliderInitialized === 'true') return;
    shell.dataset.homeSliderInitialized = 'true';

    const slider = shell.querySelector('.home-slider-shell__slider');
    if (!slider) return;

    const startedAt = Date.now();
    let revealed = false;
    let visibleChecks = 0;

    const tryReveal = () => {
      if (revealed) return true;

      const isVisible = sliderIsVisible(slider);

      if (isVisible) {
        visibleChecks += 1;
      } else {
        visibleChecks = 0;
      }

      const isStable = visibleChecks >= STABLE_VISIBLE_CHECKS;
      if (!isStable) return false;

      revealed = true;
      const elapsed = Date.now() - startedAt;
      const remainingDelay = Math.max(0, MIN_READY_DELAY_MS - elapsed);
      window.setTimeout(() => revealSlider(shell), remainingDelay);
      return true;
    };

    window.addEventListener('message', (event) => {
      try {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        if (!data) return;

        if (data.message === 'loaded' || data.message === 'view loaded') {
          window.setTimeout(tryReveal, 400);
        }
      } catch (error) {
        // Ignore non-JSON postMessages
      }
    });

    const observer = new MutationObserver(() => {
      tryReveal();
    });

    observer.observe(slider, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'class', 'style', 'height']
    });

    slider.addEventListener(
      'load',
      (event) => {
        if (event.target.tagName === 'IMG' || event.target.tagName === 'IFRAME') {
          window.setTimeout(tryReveal, 100);
        }
      },
      true
    );

    const powrRoot = getPowrRoot(slider);
    if (powrRoot && typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(() => {
        tryReveal();
      });
      resizeObserver.observe(powrRoot);

      const iframe = powrRoot.querySelector('iframe');
      if (iframe) resizeObserver.observe(iframe);

      window.setTimeout(() => resizeObserver.disconnect(), MAX_WAIT_MS);
    }

    const poll = window.setInterval(() => {
      tryReveal();
      if (revealed) window.clearInterval(poll);
    }, POLL_INTERVAL_MS);

    window.setTimeout(() => {
      window.clearInterval(poll);
      observer.disconnect();
    }, MAX_WAIT_MS);

    if (document.readyState === 'complete') {
      window.setTimeout(tryReveal, 150);
    } else {
      window.addEventListener('load', () => window.setTimeout(tryReveal, 250), { once: true });
    }
  }

  function initAll(root) {
    root.querySelectorAll('[data-home-slider-shell]').forEach(initHomeSliderShell);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
